import ApiService from '../../../../../../services/ApiService'
import Utils from '../../../../../../Utils/FormatDate'
import ServiceOrderRatings from '../ServiceOrderRatings/serviceOrderRatings.vue'
import RankingSupplier from '../RankingSupplier/rankingSupplier.vue'
import AdhesionCalledModule from '../AdhesionCalledModule/adhesionCalledModule.vue'
import ServiceForecast from '../ServiceForecast/serviceForecast.vue'
import ResolutionForecast from '../ResolutionForecast/resolutionForecast.vue'
import CallsAnsweredChart from '../CallsAnsweredChart/index.vue'
import CallsResolvedChart from '../CallsResolvedChart/index.vue'

import moment from 'moment'

export default {
  components: {
    ServiceOrderRatings,
    RankingSupplier,
    AdhesionCalledModule,
    ServiceForecast,
    ResolutionForecast,
    CallsAnsweredChart,
    CallsResolvedChart,
  },

  async created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institutionId = JSON.parse(localStorage.getItem('institution')).id
    this.getInstitutions()

    if (this.institution.userType > 1) {
      this.getUserUnidades()
    } else {
      this.getUnidades()
    }

    this.filter.institutionId = this.institutionId

    if (this.institution.userType == 5) {
      this.unidadeIds = [userLogged.unidadeId]
    }

    this.getWorkshops()
  },

  data: () => ({
    unitySearch: '',
    workshopSearch: '',
    institution: {},
    loading: false,
    institutionLoading: false,
    unidadeLoading: false,
    standardEquipmentLoading: false,
    menuStartDate: false,
    menuEndDate: false,
    startDate: new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1)
      .toISOString()
      .substr(0, 7),
    endDate: new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1)
      .toISOString()
      .substr(0, 7),
    filterStartDate: null,
    filterEndDate: null,
    minDate: null,
    page: 1,
    pageSize: 7,
    institutionId: null,
    institutions: [],
    unidadeIds: [],
    unidades: [],
    userLogged: {},
    workshopTypes: [
      { text: 'Engenharia Clínica', value: 0 },
      { text: 'Carpintaria', value: 1 },
      { text: 'Elétrica', value: 2 },
      { text: 'Hidráulica', value: 3 },
      { text: 'Climatização', value: 4 },
      { text: 'Gasoterapia', value: 5 },
      { text: 'Zeladoria', value: 6 },
      { text: 'Vidraçaria', value: 7 },
      { text: 'Mecânica', value: 8 },
      { text: 'Serralheria', value: 9 },
      { text: 'Predial Civil', value: 10 },
      { text: 'Pintura Predial', value: 11 },
      { text: 'Pintura Industrial', value: 12 },
    ],
    filter: {
      page: 1,
      pageSize: 7,
      institutionId: null,
      unidadeIds: [],
      startDate: new Date(
        new Date().getFullYear(),
        new Date().getMonth() - 1,
        1
      ).toISOString(),
      endDate: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        0
      ).toISOString(),
    },
    callsAnsweredKey: false,
    callsResolvedKey: false,
    apiService: new ApiService(),
  }),

  methods: {
    removeWorkshop(item) {
      this.filter.workshops.splice(item, 1)
      this.filter.workshops = [...this.filter.workshops]
    },
    removeUnidade(item) {
      this.unidadeIds.splice(item, 1)
      this.unidadeIds = [...this.unidadeIds]
    },

    getWorkshops() {
      this.apiService
        .get('workshop/' + this.institution.id)
        .then((response) => {
          this.workshopTypes = response.content
        })
    },

    setDates() {
      const startYear = this.startDate.split('-')[0]
      const startMonth = this.startDate.split('-')[1]
      const endYear = this.endDate.split('-')[0]
      const endMonth = this.endDate.split('-')[1]

      this.filter.startDate = moment(
        startYear + '-' + startMonth + '-' + 1
      ).format('yyyy-MM-DD')
      this.filter.endDate = moment(new Date(endYear, endMonth, 0)).format(
        'yyyy-MM-DD'
      )
    },

    async getUserUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/listByUserAndInstitution/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService
        .get('institution/list')
        .then((response) => {
          this.institutions = response.content
          this.institutionLoading = false
        })
        .catch((err) => {})
    },

    async getUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    filterTables() {
      this.filter.page = this.page
      this.filter.pageSize = this.pageSize
      this.filter.institutionId = this.institutionId
      this.filter.unidadeIds = this.unidadeIds

      this.setDates()

      this.callsAnsweredKey = !this.callsAnsweredKey
      this.callsResolvedKey = !this.callsResolvedKey

      this.$refs.ratings.listRatings()
      this.$refs.rankings.listRankings()
      this.$refs.calledModule.listCalleds()
      this.$refs.serviceForecast.listServiceForecast()
      this.$refs.resolutionForecast.listResolutionForecast()
    },

    reset() {
      if (this.institution.userType == 5) {
        this.unidadeIds = [this.userLogged.unidadeId]
      } else {
        this.unidadeIds = []
      }
      this.filter = {
        page: 1,
        pageSize: 7,
        institutionId: null,
        unidadeIds: [],
        startDate: new Date(
          new Date().getFullYear(),
          new Date().getMonth() - 1,
          1
        ).toISOString(),
        endDate: new Date(
          new Date().getFullYear(),
          new Date().getMonth() + 1,
          0
        ).toISOString(),
      }
      this.startDate = null
      this.endDate = null
      this.filterStartDate = null
      this.filterEndDate = null
      this.page = 1
      this.pageSize = 3

      this.$refs.ratings.filterProp = this.filter
      this.$refs.rankings.filterProp = this.filter
      this.$refs.calledModule.filterProp = this.filter
      this.$refs.serviceForecast.filterProp = this.filter
      this.$refs.resolutionForecast.filterProp = this.filter

      this.$refs.ratings.page = this.page
      this.$refs.rankings.page = this.page
      this.$refs.calledModule.page = this.page
      this.$refs.serviceForecast.page = this.page
      this.$refs.resolutionForecast.page = this.page

      this.filterTables()
    },

    formatMonth(date) {
      return moment(date).locale(this.$i18n.locale).format('MMMM/YYYY')
    },

    getFirstDayLastMonth(date) {
      return Utils.getFirstDayLastMonth(date)
    },

    getEndDayLastMonth(date) {
      return Utils.getEndDayLastMonth(date)
    },

    formatDate(date) {
      return Utils.moment(date)
    },

    parseDate(date) {
      if (!date) return null

      const [day, month, year] = date.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },

    save(date) {
      this.startDate = this.formatInputDate(this.filterStartDate)
      this.$refs.menuStartDate.save(date)
      this.minDate = new Date(this.filterStartDate).toISOString().substr(0, 10)
      this.endDate = this.formatInputDate(this.filterEndDate)
      this.$refs.menuEndDate.save(date)
    },
  },
}
